import lightbox from '../vendor/lightbox.min'

jQuery(function($){

  if(typeof $('.featured-posts').slick !== "undefined") {

    $('.featured-posts').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '0px',
      autoplay: true,
      autoplaySpeed: 3500,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            centerMode: true,
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            centerMode: false,
          }
        }
      ]
    });

  }

  lightbox.option({
    'alwaysShowNavOnTouchDevices': true,
    'disableScrolling': true,
    'disableScrollingHTMLElement': "html",
    'albumLabel': "Image %1 sur %2"
  })
});